export default __webpack_public_path__ + "static/media/people-group-in-modal.774cedec.svg";